<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import formEdit from './add'

export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Thêm mới công việc",
      mode: 'add',
      models: {},
      componentKey: 0,
      page_transaction: null,
      id: null
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editWork' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa công việc' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-work' });
    },
    async saveData(params) {
      if (!params || Object.entries(params).length === 0) {
        console.error("Invalid parameters passed to saveData:", params);
        return;
      }

      
      var user_assign = '';
      for (let i = 0; i < params.user.length; i++) {
        if (i > 0) {
          user_assign += ', ';
        }
        user_assign += params.user[i].fullname;
      }

      const objects = {
        type_work_id: params.type_work.id,
        name: params.name,
        deadline_time: params.deadline_time,
        work_assign: user_assign,
        content: params.content,
        current_status_id: params.status_id
      };

      var that = this;
      if (this.mode === "add") {
        await this.$apollo.mutate({
          mutation: DataServices.insertData("work"),
          variables: { objects },
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            var returning = res.data[Object.keys(res.data)].returning[0];

            //insert farm_has_work
            await this.$apollo.mutate({
              mutation: DataServices.deleteData("farm_has_work"),
              variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
            });
            var farm_has_work = {
              farm_id: params.farm.id,
              work_id: returning.id,
            };
            let farm_variables = {
              objects: farm_has_work
            };
            await this.$apollo.mutate({
              mutation: DataServices.insertData("farm_has_work"),
              variables: farm_variables,
            });

            //insert unit_has_work
            await this.$apollo.mutate({
              mutation: DataServices.deleteData("unit_has_work"),
              variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
            });
            var unit_has_work = [];
            for (let i = 0; i < params.unit.length; i++) {
              unit_has_work.push({
                unit_id: params.unit[i].id,
                work_id: returning.id,
              });
            }
            let unit_variables = {
              objects: unit_has_work
            };
            await this.$apollo.mutate({
              mutation: DataServices.insertData("unit_has_work"),
              variables: unit_variables,
            });

            //insert work_assign_user
            await this.$apollo.mutate({
              mutation: DataServices.deleteData("work_assign_user"),
              variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
            });
            var work_assign_user = [];
            for (let i = 0; i < params.user.length; i++) {
              work_assign_user.push({
                uid: params.user[i].id,
                work_id: returning.id,
              });
            }
            let user_variables = {
              objects: work_assign_user
            };
            await this.$apollo.mutate({
              mutation: DataServices.insertData("work_assign_user"),
              variables: user_variables,
            });
            this.redirectEdit();
          } else {
            that.$toast.add({
              severity: "error",
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
              life: 3000,
            });
            this.$commonFuction.is_loading(false);
          }
        }).catch(async error => {
          console.log("error", error);
          that.$toast.add({
            severity: "error",
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000,
          });
          this.$commonFuction.is_loading(false);
        })

      //EDIT  
      } else {
        let variables = {
          'data_update': objects,
          'where_key' : { 'id': { '_eq': this.models.id } },
        };
        await this.$apollo.mutate({
          mutation: DataServices.updateData("work"),
          variables: variables,
        // }).then(async (res) => {
        //   if (res.data[Object.keys(res.data)].affected_rows) {
        //     var returning = res.data[Object.keys(res.data)].returning[0];

        //     //insert farm_has_work
        //     await this.$apollo.mutate({
        //       mutation: DataServices.deleteData('farm_has_work'),
        //       variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
        //     });
        //     var farm_has_work = {
        //       farm_id: params.farm.id,
        //       work_id: returning.id,
        //     };
        //     let farm_variables = {
        //       objects: farm_has_work
        //     };
        //     await this.$apollo.mutate({
        //       mutation: DataServices.insertData('farm_has_work'),
        //       variables: farm_variables,
        //     });

        //     //insert unit_has_work
        //     await this.$apollo.mutate({
        //       mutation: DataServices.deleteData('unit_has_work'),
        //       variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
        //     });
        //     var unit_has_work = [];
        //     for (let i = 0; i < params.unit.length; i++) {
        //       unit_has_work.push({
        //         unit_id: params.unit[i].id,
        //         work_id: returning.id,
        //       });
        //     }
        //     let unit_variables = {
        //       objects: unit_has_work
        //     };
        //     await this.$apollo.mutate({
        //       mutation: DataServices.insertData('unit_has_work'),
        //       variables: unit_variables,
        //     });

        //     //insert work_assign_user
        //     await this.$apollo.mutate({
        //       mutation: DataServices.deleteData('work_assign_user'),
        //       variables: {'where_key': { 'work_id': { '_eq': returning.id } } },
        //     });
        //     var work_assign_user = [];
        //     for (let i = 0; i < params.user.length; i++) {
        //       work_assign_user.push({
        //         user_id: params.user[i].id,
        //         work_id: returning.id,
        //       });
        //     }
        //     let user_variables = {
        //       objects: work_assign_user
        //     };
        //     await this.$apollo.mutate({
        //       mutation: DataServices.insertData('work_assign_user'),
        //       variables: user_variables,
        //     });
        //     this.redirectEdit();
        //   } else {
        //     that.$toast.add({
        //       severity: "error",
        //       summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
        //       detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
        //       life: 3000,
        //     });
        //     this.$commonFuction.is_loading(false);
        //   }
        // }).catch(async error => {
        //   console.log("error", error);
        //     that.$toast.add({
        //     severity: "error",
        //     summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
        //     detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
        //     life: 3000,
        //   });
        //   this.$commonFuction.is_loading(false);
        })
        this.redirectEdit();
      }
    },

    async redirectEdit() {
      var  that = this;
      var router_back = { path: '/admin/list-work' };
      that.$commonFuction.is_loading(false);

      if (that.mode === "add") {
        that.$router.push(router_back);
      } else {
        if (!that.$commonFuction.isEmpty(router_back)) {
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },

    async getData(id) {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList("work"),
          variables: { where_key: { id: { _eq: id } } },
          fetchPolicy: "network-only",
        });

        const models = data[Object.keys(data)];
        if (models.length > 0) {
          this.models = { ...models[0] }; // Spread to avoid reactivity issues
          this.componentKey++;
        }
      } catch (error) {
        console.error("Error fetching data for ID:", id, error);
      }
    },
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
</style>